export const words: string[] = [
  '色情网站',
  '黄色网站',
  '成人网站',
  '强奸',
  '性侵',
  '性骚扰',
  '性虐待',
  '人渣',
  '王八蛋',
  '狗屎',
  '去死',
  '滚蛋',
  '滚开',
  '他妈的',
  '妈的',
  '卧槽',
  '我靠',
  '我草',
  '草泥马',
  '马勒戈壁',
  '装逼',
  '牛逼',
  '操你妈',
  '草你妈',
  '干你妈',
  '日你妈',
  '你妈',
  '你妈的',
  '你妈逼',
  '你妈了个逼',
  '你妈死了',
  '你爹死了',
  '你全家死了',
  '死全家',
  '全家死光',
  '死妈',
  '死爹',
  '死全家',
  '滚你妈的',
  '滚你妈',
  '滚你爹',
  '滚你全家',
  '去你妈的',
  '去你妈',
  '去你爹',
  '去你全家',
  '你妈炸了',
  '你爹炸了',
  '你全家炸了',
  '屌丝',
  '屌毛',
  '鸡巴',
  '鸡鸡',
  '鸡儿',
  '鸡巴毛',
  '鸡巴玩意',
  '鸡巴东西',
  '操蛋',
  '操你',
  '草你',
  '干你',
  '日你',
  '你妹',
  '你妹的',
  '你大爷',
  '你大爷的',
  '你丫',
  '你丫的',
  '你奶奶',
  '你奶奶的',
  '你姥姥',
  '你姥姥的',
  '你祖宗',
  '你祖宗的',
  '龟孙子',
  '龟儿子',
  '王八',
  '王八羔子',
  '狗娘养的',
  '狗日的',
  '狗东西',
  '狗屎',
  '狗屁',
  '放屁',
  '屁话',
  '扯淡',
  '胡说',
  '胡说八道',
  '瞎说',
  '瞎扯',
  '瞎掰',
  '滚犊子',
  '滚蛋',
  '滚开',
  '滚一边去',
  '滚远点',
  '滚蛋吧',
  '滚开吧',
  '滚远点吧',
  '去死吧',
  '去死',
  '死开',
  '死远点',
  '死一边去',
  '死开去',
  '死去吧',
  '三级片',
  '个老子的',
  '乳波臀浪',
  '交配',
  '仆街',
  '他奶奶',
  '他奶奶的',
  '他奶娘的',
  '他妈',
  '他妈ㄉ王八蛋',
  '他妈地',
  '他娘',
  '他马的',
  '你个傻比',
  '你他马的',
  '你全家',
  '你她马的',
  '你娘',
  '你娘卡好',
  '你娘咧',
  '你它妈的',
  '你它马的',
  '你是鸡',
  '你是鸭',
  '你老味',
  '你老母',
  '你老闆',
  '你马的',
  '做爱',
  '册那',
  '冚家拎',
  '冚家鏟',
  '几八',
  '几叭',
  '几巴',
  '几芭',
  '刚度',
  '刚瘪三',
  '口肯',
  '叫床',
  '吃屎',
  '吹箫',
  '咸家伶',
  '咸家鏟',
  '塞你公',
  '塞你娘',
  '塞你母',
  '塞你爸',
  '塞你老师',
  '塞你老母',
  '大卵子',
  '大卵泡',
  '大鸡巴',
  '奶奶的熊',
  '奸你',
  '她妈地',
  '她妈的',
  '她马的',
  '妈B',
  '妈个B',
  '妈个比',
  '妈个老比',
  '妈妈的',
  '妈比',
  '妈的B',
  '妈逼',
  '妳她妈的',
  '妳妈的',
  '妳娘的',
  '妳老母的',
  '妳马的',
  '姘头',
  '姣西',
  '娘个比',
  '娘的',
  '婊子',
  '婊子养的',
  '它妈地',
  '它妈的',
  '射你',
  '射精',
  '小卵子',
  '小卵泡',
  '小瘪三',
  '小肉粒',
  '小骚比',
  '小骚货',
  '小鸡巴',
  '小鸡鸡',
  '屎忽',
  '干x娘',
  '干七八',
  '干你娘',
  '干你老母',
  '干你良',
  '干妳妈',
  '干妳娘',
  '干妳老母',
  '干妳马',
  '干您娘',
  '干机掰',
  '干死CS',
  '干死GM',
  '干死你',
  '干死客服',
  '强奸你',
  '性交',
  '性器',
  '性爱',
  '想上你',
  '懆您妈',
  '懆您娘',
  '懒8',
  '懒八',
  '懒叫',
  '懒教',
  '我操你祖宗十八代',
  '扒光',
  '打炮',
  '打飞机',
  '抽插',
  '插你',
  '插死你',
  '撒尿',
  '操你全家',
  '操你奶奶',
  '操你娘',
  '操你祖宗',
  '操你老妈',
  '操你老母',
  '操妳',
  '操妳全家',
  '操妳妈',
  '操妳娘',
  '操妳祖宗',
  '操机掰',
  '操比',
  '操逼',
  '日他娘',
  '日你老娘',
  '日你老母',
  '日批',
  '机八',
  '机巴',
  '机机歪歪',
  '杂种',
  '浪叫',
  '湿透的内裤',
  '灨你娘',
  '烂逼',
  '狗日',
  '狗狼养的',
  '瓜批',
  '瘪三',
  '白烂',
  '白癡',
  '硬膠',
  '祖宗',
  '粉腸',
  '老二',
  '老瘪三',
  '老骚比',
  '老骚货',
  '肥西',
  '花柳',
  '贝肉',
  '贱B',
  '贱人',
  '贱货',
  '贼你妈',
  '赛你老母',
  '赛妳阿母',
  '赣您娘',
  '躝癱',
  '轮奸',
  '迷药',
  '逼样',
  '野鸡',
  '雞巴',
  '靠北',
  '靠母',
  '靠爸',
  '靠背',
  '靠腰',
  '驶你公',
  '驶你娘',
  '驶你母',
  '驶你爸',
  '驶你老师',
  '驶你老母',
  '骚比',
  '骚货',
  '骚逼',
  '鬼公',
  '鸡8',
  '鸡八',
  '鸡叭',
  '鸡吧',
  '鸡奸',
  '鸡芭',
];
